export const TERTIARY_NAVIGATION_TEST_IDS = {
  actionButton: 'tertiary-navigation__action-button',
  actions: 'tertiary-navigation__actions',
  aiButton: 'tertiary-navigation__ai-button',
  aiPrompt: 'tertiary-navigation__ai-prompt',
  aiPromptInput: 'tertiary-navigation__ai-prompt-input',
  aiPromptPanel: 'tertiary-navigation__ai-prompt-panel',
  aiPromptSubmitHint: 'tertiary-navigation__ai-prompt-submit-hint',
  aiPromptTrigger: 'tertiary-navigation__ai-prompt-trigger',
  currencySelector: 'tertiary-navigation__currency-selector',
  currencyUnit: 'tertiary-navigation__currency-unit',
  currencyValue: 'tertiary-navigation__currency-value',
  item: (value: string) => `tertiary-navigation__item-${value}`,
  itemClose: (value: string) => `tertiary-navigation__item-close-${value}`,
  itemMenu: (value: string) => `tertiary-navigation__item-menu-${value}`,
  items: 'tertiary-navigation__items',
  itemsScrollLeft: 'tertiary-navigation__items-scroll-left',
  itemsScrollRight: 'tertiary-navigation__items-scroll-right',
  leftActions: 'tertiary-navigation__left-actions',
  root: 'tertiary-navigation',
  skeleton: 'tertiary-navigation__skeleton',
  splitActionButton: 'tertiary-navigation__split-action-button',
  splitActionMainButton: 'tertiary-navigation__split-action-main-button',
  splitActionMenuButton: 'tertiary-navigation__split-action-menu-button',
} as const;
